(function () {
  'use strict';

  var dataEl = document.getElementById('fm-bundle-data');
  if (!dataEl) return;

  var data;
  try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var bundles = data.bundles || {};
  var settings = data.settings || {};
  var colors = data.colors || [];
  var state = { bundle: data.defaultBundle || 'duo', slots: [] };

  window.fmBundle = window.fmBundle || {};

  var badgeEl = null;
  var isBasicBundle = false;
  var isFirstMediaActive = true;

  // ─── Hero badge injection + visibility ───────────────────────────────────
  function ensureBadge() {
    if (badgeEl) return badgeEl;
    // Section toggle — when off, badge is never injected. All downstream
    // helpers (applyBadgeVisibility, label setters) already null-guard, so
    // returning null here disables the badge cleanly without crashes.
    if (!settings.show_dynamic_badge) return null;
    // Attach to the sticky <media-gallery> element (has .product__column-sticky
    // ≥ 750px → position: sticky). Falls back to non-sticky containers when
    // media-gallery is missing. Sticky ancestor = sticky offset-parent → badge
    // clings to the hero image during scroll instead of drifting off with the
    // outer .product__media-wrapper.
    var target = document.querySelector('media-gallery') ||
                 document.querySelector('.product__media-list') ||
                 document.querySelector('.product__media-wrapper') ||
                 document.querySelector('.product__media');
    if (!target) return null;
    if (getComputedStyle(target).position === 'static') target.style.position = 'relative';
    badgeEl = document.createElement('div');
    badgeEl.className = 'fm-hero-badge';
    badgeEl.setAttribute('aria-hidden', 'true');
    badgeEl.innerHTML =
      '<span id="fm-badge-l1"></span>' +
      '<span id="fm-badge-l2"></span>' +
      '<span id="fm-badge-l3"></span>';
    target.appendChild(badgeEl);
    return badgeEl;
  }

  function applyBadgeVisibility() {
    if (!badgeEl) return;
    var shouldShow = !isBasicBundle && isFirstMediaActive;
    badgeEl.style.display = shouldShow ? '' : 'none';
  }

  function watchActiveMedia() {
    var list = document.querySelector('.product__media-list');
    if (!list) return;
    var firstItem = list.querySelector('.product__media-item');
    if (!firstItem) return;
    var firstZoomIcon = firstItem.querySelector('.product__media-icon');

    function updateFlag() {
      var anyActive = list.querySelector('.product__media-item.is-active');
      isFirstMediaActive = anyActive ? firstItem.classList.contains('is-active') : true;
      applyBadgeVisibility();
      if (firstZoomIcon) {
        firstZoomIcon.style.display = isFirstMediaActive ? 'none' : '';
      }
    }

    updateFlag();
    var observer = new MutationObserver(updateFlag);
    list.querySelectorAll('.product__media-item').forEach(function (item) {
      observer.observe(item, { attributes: true, attributeFilter: ['class'] });
    });
  }

  function getHeroImg() { return document.querySelector('.product__media img'); }

  // Strip cache-buster query string so two URLs that point at the same file
  // (e.g. ?v=…&width=…) compare equal.
  function stripQuery(u) { return (u || '').split('?')[0]; }

  function swapHeroImage(img, newSrc) {
    if (!img || !newSrc) return;
    if (stripQuery(img.getAttribute('src')) === stripQuery(newSrc)) return;

    // Lock aspect-ratio before swap so the container can't collapse while the
    // new image is loading — prevents the document scroll position from being
    // pushed by a momentary 0-height <img>.
    if (!img.style.aspectRatio && img.naturalWidth && img.naturalHeight) {
      img.style.aspectRatio = img.naturalWidth + ' / ' + img.naturalHeight;
    }

    img.setAttribute('src', newSrc);
    img.removeAttribute('srcset');
  }

  // ─── Color Discovery (above price block) ────────────────────────────────
  function applyDiscoveryImages() {
    var cd = data.colorDiscovery || {};
    var items = cd.items || [];
    if (cd.title) {
      var titleEl = document.getElementById('fm-color-discovery-title');
      if (titleEl) titleEl.textContent = cd.title;
    }
    var byHandle = {};
    items.forEach(function (it) { byHandle[it.handle] = it; });
    document.querySelectorAll('.fm-color-swatch').forEach(function (btn) {
      var handle = btn.getAttribute('data-color-handle');
      var item = byHandle[handle];
      if (!item) return;
      var imgEl = btn.querySelector('.fm-color-swatch__img');
      if (imgEl) {
        imgEl.style.backgroundImage =
          "image-set(url('" + item.image400 + "') 1x, url('" + item.image800 + "') 2x)," +
          "url('" + item.image400 + "')";
      }
      var labelEl = btn.querySelector('.fm-color-swatch__label');
      if (labelEl && item.name) labelEl.textContent = item.name;
      btn.setAttribute('aria-label', item.name + ' wählen');
    });
  }

  function bindDiscoverySwatches() {
    var swatches = document.querySelectorAll('.fm-color-swatch');
    if (!swatches.length) return;
    swatches.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var handle = btn.getAttribute('data-color-handle');
        if (!handle) return;
        // Swatch navigiert zur jeweiligen Colorway-PDP — einheitlich auf
        // Bundle-PDP und künftiger Colorway-PDP. Slot-Logik bleibt
        // UNANGETASTET (nur über "+"-Slot → Modal → Color-Tile).
        var url = '/products/' + handle;
        if (window.location.pathname.indexOf(url) === -1) {
          window.location.href = url;
        }
      });
    });
  }

  function applyCardLabels() {
    var cards = [
      { key: 'basic', eyebrow: settings.card_basic_eyebrow, title: settings.card_basic_title, subtitle: settings.card_basic_subtitle },
      { key: 'duo',   eyebrow: settings.card_duo_eyebrow,   title: settings.card_duo_title,   subtitle: settings.card_duo_subtitle },
      { key: 'trio',  eyebrow: settings.card_trio_eyebrow,  title: settings.card_trio_title,  subtitle: settings.card_trio_subtitle }
    ];
    cards.forEach(function (c) {
      var cardEl = document.querySelector('.fm-bundle-card[data-bundle="' + c.key + '"]');
      if (!cardEl) return;
      var eyebrowEl = cardEl.querySelector('.fm-bundle-card__banner');
      var titleEl   = cardEl.querySelector('.fm-bundle-card__name');
      var subEl     = cardEl.querySelector('.fm-bundle-card__desc');
      if (eyebrowEl && c.eyebrow != null) eyebrowEl.textContent = c.eyebrow;
      if (titleEl   && c.title   != null) titleEl.textContent   = c.title;
      if (subEl     && c.subtitle != null) subEl.textContent    = c.subtitle;
    });
  }

  // ─── Bundle selection ────────────────────────────────────────────────────
  function setBundle(key) {
    var cfg = bundles[key];
    if (!cfg) return;
    state.bundle = key;

    var priceOld = document.getElementById('fm-price-old');
    var priceNew = document.getElementById('fm-price-new');
    var discount = document.getElementById('fm-discount');
    var perUnitWrap = document.getElementById('fm-per-unit-wrap');
    var perUnit = document.getElementById('fm-per-unit');
    var sub = document.getElementById('fm-sub');

    if (sub) sub.textContent = cfg.sub;
    if (priceNew) priceNew.textContent = cfg.price;

    var isBasic = key === 'basic';
    isBasicBundle = isBasic;

    if (priceOld) {
      priceOld.style.display = isBasic ? 'none' : '';
      if (!isBasic && cfg.strike) priceOld.textContent = cfg.strike;
    }
    if (discount) {
      discount.style.display = isBasic ? 'none' : '';
      if (!isBasic && cfg.discount) discount.textContent = cfg.discount;
    }
    if (perUnitWrap) {
      perUnitWrap.style.display = isBasic ? 'none' : '';
      if (!isBasic && cfg.perUnit && perUnit) perUnit.textContent = cfg.perUnit;
    }

    var badge = ensureBadge();
    if (badge && !isBasic && cfg.badge) {
      var l1 = document.getElementById('fm-badge-l1');
      var l2 = document.getElementById('fm-badge-l2');
      var l3 = document.getElementById('fm-badge-l3');
      if (l1) l1.textContent = cfg.badge.l1;
      if (l2) l2.textContent = cfg.badge.l2;
      if (l3) l3.textContent = cfg.badge.l3;
    }
    applyBadgeVisibility();

    // Galerie-Swap nur, wenn die Section es nicht deaktiviert (Colorway-PDP:
    // Galerie bleibt statisch beim PDP-Colorway). Bundle-PDP: weiter-swappen.
    if (!settings.disable_hero_swap) {
      swapHeroImage(getHeroImg(), cfg.heroImage);
    }

    var targetLen = isBasic ? 1 : (key === 'duo' ? 2 : (key === 'trio' ? 3 : 4));
    if (state.slots.length > targetLen) state.slots.length = targetLen;

    var cards = document.querySelectorAll('.fm-bundle-card');
    cards.forEach(function (card) {
      var active = card.getAttribute('data-bundle') === key;
      card.classList.toggle('is-active', active);
      card.setAttribute('aria-checked', active ? 'true' : 'false');
      card.setAttribute('tabindex', active ? '0' : '-1');
    });

    renderSlots();
    updateCounter();
    updateCta();

    document.dispatchEvent(new CustomEvent('fm:bundle-change', {
      detail: { bundle: key, config: cfg, targetLen: targetLen }
    }));
  }

  function bindBundleCards() {
    var cards = document.querySelectorAll('.fm-bundle-card');
    cards.forEach(function (card, idx) {
      card.addEventListener('click', function () {
        setBundle(card.getAttribute('data-bundle'));
      });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
          e.preventDefault();
          var next = cards[(idx + 1) % cards.length];
          setBundle(next.getAttribute('data-bundle'));
          next.focus();
        } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
          e.preventDefault();
          var prev = cards[(idx - 1 + cards.length) % cards.length];
          setBundle(prev.getAttribute('data-bundle'));
          prev.focus();
        } else if (e.key === ' ' || e.key === 'Enter') {
          e.preventDefault();
          setBundle(card.getAttribute('data-bundle'));
        }
      });
    });
  }

  // ─── Slot picker ─────────────────────────────────────────────────────────
  function targetLen() {
    if (state.bundle === 'basic') return 1;
    if (state.bundle === 'duo') return 2;
    if (state.bundle === 'trio') return 3;
    if (state.bundle === 'fourer') return 4;
    return 3; // safety default
  }

  function colorByHandle(handle) {
    for (var i = 0; i < colors.length; i++) if (colors[i].handle === handle) return colors[i];
    return null;
  }

  function renderSlots() {
    var slotEls = document.querySelectorAll('.fm-slot');
    var len = targetLen();

    // Grid-Layout-Hinweis für CSS: cols-2/3/4 wird per [data-bundle-mode]
    // gesteuert. 4er = 2×2-Raster mit Drittel-Breite pro Slot.
    var gridEl = document.getElementById('fm-slots');
    if (gridEl) gridEl.setAttribute('data-bundle-mode', state.bundle);

    slotEls.forEach(function (el, idx) {
      if (idx >= len) {
        el.classList.add('is-hidden');
        el.removeAttribute('data-badge');
        return;
      }
      el.classList.remove('is-hidden');

      // Slot badge based on bundle
      if (state.bundle === 'duo') {
        el.setAttribute('data-badge', settings.slot_badge_discount || '−15%');
      } else if (state.bundle === 'trio' && idx === 2) {
        el.setAttribute('data-badge', settings.slot_badge_free || 'GRATIS');
      } else if (state.bundle === 'fourer') {
        el.setAttribute('data-badge', settings.slot_badge_fourer || '−35%');
      } else {
        el.removeAttribute('data-badge');
      }

      // Fill state
      var handle = state.slots[idx];
      var color = handle ? colorByHandle(handle) : null;

      // If color became unavailable, clear slot
      if (color && color.available === false) {
        state.slots[idx] = null;
        color = null;
      }

      if (color) {
        el.classList.add('is-filled');
        el.style.setProperty('--fm-slot-color', color.hex);
        el.setAttribute('aria-label', 'Slot ' + (idx + 1) + ' – ' + color.name + ', antippen zum Ändern');
        var firstSlotImg = color.images && color.images[0];
        var slotImgMarkup = firstSlotImg ? (
          '<img class="fm-slot__img" alt="" ' +
          'src="' + escapeAttr(firstSlotImg.src400) + '" ' +
          'srcset="' + escapeAttr(firstSlotImg.src400) + ' 400w, ' + escapeAttr(firstSlotImg.src800) + ' 800w" ' +
          'sizes="(max-width: 750px) 33vw, 200px" loading="eager" decoding="async">'
        ) : '';
        el.innerHTML = slotImgMarkup +
          '<span class="fm-slot__name-tag">' + escapeHtml(color.name) + '</span>' +
          '<button type="button" class="fm-slot__remove" aria-label="' +
          escapeHtml(color.name) + ' aus Slot ' + (idx + 1) + ' entfernen" data-remove="' + idx + '">×</button>';
      } else {
        el.classList.remove('is-filled');
        el.style.setProperty('--fm-slot-color', '#f4f3f0');
        el.setAttribute('aria-label', 'Slot ' + (idx + 1) + ' – leer, antippen um Design zu wählen');
        el.innerHTML = '<span class="fm-slot__plus" aria-hidden="true">+</span>';
      }
    });
  }

  function updateCounter() {
    var countEl = document.getElementById('fm-count');
    if (!countEl) return;
    var len = targetLen();
    var filled = state.slots.filter(function (s) { return !!s; }).length;
    countEl.textContent = filled + ' von ' + len + ' ausgewählt';
  }

  // ─── CTA ─────────────────────────────────────────────────────────────────
  var ctaBtn = null;
  var ctaErrorEl = null;
  var cartPending = false;
  var CART_ERROR_MSG = 'Leider konnte der Warenkorb nicht aktualisiert werden. Bitte versuche es erneut.';

  function firstEmptySlotIdx() {
    var len = targetLen();
    for (var i = 0; i < len; i++) {
      if (!state.slots[i]) return i;
    }
    return 0;
  }

  function ctaText() {
    var len = targetLen();
    var filled = state.slots.filter(function (s) { return !!s; }).length;
    var remaining = len - filled;
    if (remaining === 0) {
      var price = bundles[state.bundle] && bundles[state.bundle].price;
      return price ? 'In den Warenkorb · ' + price : 'In den Warenkorb';
    }
    if (state.bundle === 'basic') return 'Wähle dein Design';
    if (filled === 0) return 'Wähle ' + len + ' Designs um fortzufahren';
    return 'Wähle ' + remaining + ' weitere' + (remaining === 1 ? 's' : '') +
           ' Design' + (remaining === 1 ? '' : 's');
  }

  function updateCta() {
    if (!ctaBtn) return;
    if (cartPending) return; // preserve pending-state text
    var len = targetLen();
    var filled = state.slots.filter(function (s) { return !!s; }).length;
    var complete = filled === len;
    ctaBtn.textContent = ctaText();
    ctaBtn.classList.toggle('is-incomplete', !complete);
    ctaBtn.setAttribute('data-state', complete ? 'complete' : 'incomplete');
  }

  function showCtaError(msg) {
    if (!ctaErrorEl) return;
    ctaErrorEl.textContent = msg;
    ctaErrorEl.hidden = false;
  }
  function hideCtaError() {
    if (!ctaErrorEl) return;
    ctaErrorEl.textContent = '';
    ctaErrorEl.hidden = true;
  }

  function aggregateItems() {
    var counts = {};
    state.slots.forEach(function (h) {
      if (h) counts[h] = (counts[h] || 0) + 1;
    });
    return Object.keys(counts).map(function (handle) {
      var c = colorByHandle(handle);
      return c ? { id: c.variantId, quantity: counts[handle] } : null;
    }).filter(Boolean);
  }

  function refreshCartUI(sections) {
    if (!sections) return false;
    var opened = false;

    if (sections['cart-drawer']) {
      var cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        try {
          var parser = new DOMParser();
          var doc = parser.parseFromString(sections['cart-drawer'], 'text/html');
          var newInner = doc.querySelector('.drawer__inner');
          var oldInner = cartDrawer.querySelector('.drawer__inner');
          if (newInner && oldInner) oldInner.innerHTML = newInner.innerHTML;
          cartDrawer.classList.remove('is-empty');
          var items = cartDrawer.querySelector('cart-drawer-items');
          if (items) items.classList.remove('is-empty');
          if (typeof cartDrawer.open === 'function') {
            cartDrawer.open();
            opened = true;
          }
        } catch (e) { /* fall through to /cart redirect */ }
      }
    }

    if (sections['cart-icon-bubble']) {
      var bubbleHost = document.getElementById('cart-icon-bubble');
      if (bubbleHost) {
        try {
          var parser2 = new DOMParser();
          var doc2 = parser2.parseFromString(sections['cart-icon-bubble'], 'text/html');
          var newBubble = doc2.querySelector('.shopify-section') || doc2.body.firstElementChild;
          if (newBubble) {
            bubbleHost.innerHTML = newBubble.innerHTML;
          }
        } catch (e) {}
      }
    }

    return opened;
  }

  function addToCart() {
    if (cartPending) return;
    var items = aggregateItems();
    if (!items.length) return;
    hideCtaError();
    cartPending = true;
    ctaBtn.disabled = true;
    var orig = ctaBtn.textContent;
    ctaBtn.textContent = 'Wird hinzugefügt …';

    fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root ?
      window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: items,
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname + window.location.search
      })
    })
    .then(function (res) {
      return res.json().then(function (body) {
        if (!res.ok) throw new Error(body.description || body.message || 'HTTP ' + res.status);
        return body;
      });
    })
    .then(function (body) {
      var opened = refreshCartUI(body.sections || {});
      cartPending = false;
      ctaBtn.disabled = false;
      if (!opened) {
        window.location.href = '/cart';
        return;
      }
      updateCta();
    })
    .catch(function (err) {
      if (window.console && console.warn) console.warn('[fmBundle] add-to-cart failed:', err);
      cartPending = false;
      ctaBtn.disabled = false;
      ctaBtn.textContent = orig;
      showCtaError(CART_ERROR_MSG);
    });
  }

  function bindCta() {
    ctaBtn = document.getElementById('fm-bundle-cta');
    ctaErrorEl = document.getElementById('fm-cta-error');
    if (!ctaBtn) return;
    ctaBtn.addEventListener('click', function () {
      var len = targetLen();
      var filled = state.slots.filter(function (s) { return !!s; }).length;
      if (filled < len) {
        openModal(firstEmptySlotIdx());
        return;
      }
      addToCart();
    });
  }

  function bindSlots() {
    var grid = document.getElementById('fm-slots');
    if (!grid) return;
    grid.addEventListener('click', function (e) {
      var removeBtn = e.target.closest('[data-remove]');
      if (removeBtn) {
        e.stopPropagation();
        var idx = parseInt(removeBtn.getAttribute('data-remove'), 10);
        if (!isNaN(idx)) {
          state.slots[idx] = null;
          renderSlots();
          updateCounter();
          updateCta();
          document.dispatchEvent(new CustomEvent('fm:slot-change', { detail: { slots: state.slots.slice() } }));
        }
        return;
      }
      var slotEl = e.target.closest('.fm-slot');
      if (!slotEl) return;
      if (slotEl.classList.contains('is-hidden')) return;
      var idx = parseInt(slotEl.getAttribute('data-slot-idx'), 10);
      if (isNaN(idx) || idx >= targetLen()) return;
      openModal(idx);
    });
    grid.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var slotEl = e.target.closest('.fm-slot');
      if (!slotEl) return;
      e.preventDefault();
      var idx = parseInt(slotEl.getAttribute('data-slot-idx'), 10);
      if (!isNaN(idx) && idx < targetLen()) openModal(idx);
    });
  }

  // ─── Modal: list + detail views ──────────────────────────────────────────
  var modalEl = null;
  var colorGridEl = null;
  var currentSlotIdx = null;
  var currentColorHandle = null;
  var currentImageIdx = 0;
  var lastFocused = null;

  function buildTiles() {
    if (!colorGridEl) return;
    colorGridEl.innerHTML = colors.map(function (c) {
      var pillMarkup = c.available ? '' :
        '<span class="fm-color-tile__pill">' + escapeHtml(settings.oos_label || '') + '</span>';
      var firstImg = c.images && c.images[0];
      var imgMarkup = firstImg ? (
        '<img class="fm-color-tile__img-el" alt="' + escapeAttr(c.name) + '" ' +
        'data-src="' + escapeAttr(firstImg.src400) + '" ' +
        'data-srcset="' + escapeAttr(firstImg.src400) + ' 400w, ' + escapeAttr(firstImg.src800) + ' 800w" ' +
        'sizes="(max-width: 750px) 50vw, 300px" loading="lazy" decoding="async">'
      ) : '';
      return (
        '<div class="fm-color-tile" data-handle="' + escapeAttr(c.handle) + '" data-available="' + (c.available ? 'true' : 'false') + '" tabindex="' + (c.available ? '0' : '-1') + '" role="button" aria-label="' + escapeAttr(c.name + (c.available ? '' : ' – nicht verfügbar')) + '">' +
          '<div class="fm-color-tile__img" style="--fm-color-hex: ' + escapeAttr(c.hex) + ';">' +
            imgMarkup +
            pillMarkup +
          '</div>' +
          '<div class="fm-color-tile__body">' +
            '<p class="fm-color-tile__name">' + escapeHtml(c.name) + '</p>' +
            '<button type="button" class="fm-color-tile__preview" data-preview="' + escapeAttr(c.handle) + '"' +
              (c.available ? '' : ' disabled aria-disabled="true" tabindex="-1"') + '>⌕ Vorschau</button>' +
          '</div>' +
        '</div>'
      );
    }).join('');
  }

  function swapLazyImages() {
    if (!modalEl) return;
    modalEl.querySelectorAll('img[data-src]').forEach(function (img) {
      if (img.src && img.src.length > 0 && !img.src.endsWith('#')) return;
      if (img.dataset.srcset) img.srcset = img.dataset.srcset;
      img.src = img.dataset.src;
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');
    });
  }

  function showList() {
    if (!modalEl) return;
    modalEl.classList.remove('is-detail');
    var title = document.getElementById('fm-modal-title');
    if (title) title.textContent = 'Wähle deine Designs';
    var closeBtn = document.getElementById('fm-modal-close');
    if (closeBtn) closeBtn.focus();
  }

  function showDetail(handle) {
    var color = colorByHandle(handle);
    if (!color) return;
    currentColorHandle = handle;
    currentImageIdx = 0;

    var hero = document.querySelector('.fm-detail__hero');
    var img = document.getElementById('fm-detail-img');
    var thumbs = document.getElementById('fm-detail-thumbs');

    if (hero) hero.style.setProperty('--fm-detail-hex', color.hex);

    if (thumbs) {
      thumbs.innerHTML = (color.images || []).map(function (src, i) {
        return '<button type="button" class="fm-detail__thumb' + (i === 0 ? ' is-active' : '') +
               '" data-img-idx="' + i + '" aria-label="Bild ' + (i + 1) + '">' +
               '<img src="' + escapeAttr(src.src400) + '" alt="" loading="lazy" decoding="async"></button>';
      }).join('');
    }
    if (img) {
      if (color.images && color.images[0]) {
        var first = color.images[0];
        img.src = first.src800;
        img.srcset = first.src400 + ' 400w, ' + first.src800 + ' 800w';
        img.sizes = '(max-width: 750px) 90vw, 600px';
        img.alt = color.name;
      } else {
        img.removeAttribute('src');
        img.removeAttribute('srcset');
        img.alt = color.name;
      }
    }

    modalEl.classList.add('is-detail');
    var title = document.getElementById('fm-modal-title');
    if (title) title.textContent = color.name;
    var back = document.getElementById('fm-modal-back');
    if (back) back.focus();
  }

  // Shared helper: swap detail hero image + srcset + active-thumb state.
  // Used by both arrow-nav and thumbnail-click so the two code paths can't drift.
  function setDetailImage(idx) {
    var color = colorByHandle(currentColorHandle);
    if (!color || !color.images || !color.images.length) return;
    if (isNaN(idx)) return;
    var entry = color.images[idx];
    if (!entry) return;
    currentImageIdx = idx;
    var img = document.getElementById('fm-detail-img');
    if (img) {
      img.src = entry.src800;
      img.srcset = entry.src400 + ' 400w, ' + entry.src800 + ' 800w';
    }
    document.querySelectorAll('.fm-detail__thumb').forEach(function (t, i) {
      t.classList.toggle('is-active', i === idx);
    });
  }

  function navigateImage(dir) {
    var color = colorByHandle(currentColorHandle);
    if (!color || !color.images || !color.images.length) return;
    var next = (currentImageIdx + dir + color.images.length) % color.images.length;
    setDetailImage(next);
  }

  function openModal(slotIdx) {
    if (!modalEl) return;
    currentSlotIdx = slotIdx;
    lastFocused = document.activeElement;
    modalEl.hidden = false;
    swapLazyImages();
    requestAnimationFrame(function () {
      modalEl.classList.add('is-open');
    });
    document.documentElement.style.overflow = 'hidden';
    showList();
  }

  function closeModal() {
    if (!modalEl) return;
    modalEl.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    setTimeout(function () {
      if (!modalEl.classList.contains('is-open')) modalEl.hidden = true;
    }, 260);
    // preventScroll verhindert, dass der Browser das (außerhalb des Modals
    // liegende) lastFocused-Element nach Modal-Close ins Viewport scrollt
    // und die Seite damit nach oben springt. Chrome 64+, FF 68+, Safari 15+.
    if (lastFocused && lastFocused.focus) lastFocused.focus({ preventScroll: true });
  }

  // Fills a slot with a color, updates dependent UI, fires fm:slot-change.
  // Does NOT close the modal — callers decide. Returns true on success.
  function fillSlot(idx, handle) {
    var color = colorByHandle(handle);
    if (!color || !color.available) return false;
    if (typeof idx !== 'number' || idx < 0 || idx >= targetLen()) return false;
    state.slots[idx] = handle;
    renderSlots();
    updateCounter();
    updateCta();
    document.dispatchEvent(new CustomEvent('fm:slot-change', { detail: { slots: state.slots.slice() } }));
    return true;
  }

  function selectColor(handle) {
    if (currentSlotIdx == null) return;
    if (fillSlot(currentSlotIdx, handle)) closeModal();
  }

  function bindModal() {
    modalEl = document.getElementById('fm-modal');
    colorGridEl = document.getElementById('fm-color-grid');
    if (!modalEl) return;

    buildTiles();

    document.getElementById('fm-modal-close').addEventListener('click', closeModal);
    modalEl.querySelector('.fm-modal__backdrop').addEventListener('click', closeModal);
    document.getElementById('fm-modal-back').addEventListener('click', showList);
    document.getElementById('fm-detail-back-link').addEventListener('click', showList);
    document.getElementById('fm-detail-prev').addEventListener('click', function () { navigateImage(-1); });
    document.getElementById('fm-detail-next').addEventListener('click', function () { navigateImage(1); });

    // Touch swipe on the detail hero — passive listeners so vertical scroll keeps working.
    // Threshold filters jitter; horizontal-vs-vertical check ignores intentional vertical scrolls.
    var heroEl = document.querySelector('.fm-detail__hero');
    if (heroEl) {
      var tStartX = 0, tStartY = 0;
      heroEl.addEventListener('touchstart', function (e) {
        var t = e.changedTouches[0];
        tStartX = t.screenX;
        tStartY = t.screenY;
      }, { passive: true });
      heroEl.addEventListener('touchend', function (e) {
        var t = e.changedTouches[0];
        var dx = t.screenX - tStartX;
        var dy = t.screenY - tStartY;
        if (Math.abs(dx) < 40) return;
        if (Math.abs(dx) < Math.abs(dy)) return;
        navigateImage(dx > 0 ? -1 : 1);
      }, { passive: true });
    }
    document.getElementById('fm-detail-select').addEventListener('click', function () {
      if (currentColorHandle) selectColor(currentColorHandle);
    });

    colorGridEl.addEventListener('click', function (e) {
      var previewBtn = e.target.closest('[data-preview]');
      if (previewBtn) {
        e.stopPropagation();
        var tile = previewBtn.closest('.fm-color-tile');
        if (tile && tile.getAttribute('data-available') === 'false') return;
        showDetail(previewBtn.getAttribute('data-preview'));
        return;
      }
      var tile = e.target.closest('.fm-color-tile');
      if (!tile) return;
      if (tile.getAttribute('data-available') === 'false') return;
      selectColor(tile.getAttribute('data-handle'));
    });

    colorGridEl.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var tile = e.target.closest('.fm-color-tile');
      if (!tile || tile.getAttribute('data-available') === 'false') return;
      e.preventDefault();
      selectColor(tile.getAttribute('data-handle'));
    });

    document.getElementById('fm-detail-thumbs').addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-img-idx]');
      if (!thumb) return;
      setDetailImage(parseInt(thumb.getAttribute('data-img-idx'), 10));
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (modalEl.classList.contains('is-open')) {
        if (modalEl.classList.contains('is-detail')) showList();
        else closeModal();
      }
    });
  }

  // ─── Utils ───────────────────────────────────────────────────────────────
  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function escapeAttr(s) { return escapeHtml(s); }

  // ─── Init ────────────────────────────────────────────────────────────────
  function init() {
    applyCardLabels();
    applyDiscoveryImages();
    bindBundleCards();
    bindSlots();
    bindDiscoverySwatches();
    bindCta();
    bindModal();
    watchActiveMedia();
    setBundle(state.bundle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.fmBundle.state = state;
  window.fmBundle.setBundle = setBundle;
  window.fmBundle.data = data;
  window.fmBundle.openSlotModal = openModal;
})();
